SP.ProductRecommendations = Garnish.Base.extend({
    productPage: null,
    $container: null,

    product: null,
    limit: null,
    count: null,

    $carousel: null,
    carousel: null,

    requestUrl: null,

    // Breakpoints
    mobile: 576,
    tablet: 769,
    laptop: 1025,
    desktop: 1278,

    init(productPage) {
        let self = this
        this.productPage = productPage
        this.$container = $('#product-recommendations')
        this.$carousel = this.$container.find('.product-recommendation-slider')
        this.product = product
        this.limit = this.$container.data('limit')
        this.requestUrl = `/recommendations/products?section_id=product-recommendations&limit=${this.limit}&product_id=${product.id}`

        if (this.product) {
            $.ajax({
                url: this.requestUrl,
                data: {},
                dataType: 'html',
                success: function (res) {
                    let html = $(res)
                    let template = html.find('.product-recommendations')
                    self.renderTemplate(template)
                },
            });
        }
    },

    renderTemplate(template) {
        let self = this
        this.$container.html(template)
        this.count = this.$container.find('.product-tile').length

        // if (this.limit > 4 && this.count > 4) {
        if (this.limit > 4) {
            this.initCarousel()
        }

        // Setup product tiles
        let productTiles = $('.product-tile')
        if (productTiles.length > 0) {
            $.each(productTiles, function (index, el) {
                new SP.ProductTile(el)
            })
        }
    },

    updateCarouselOnWinResize() {
        if (Garnish.$win.width() > this.laptop) {
            if (this.count <= 4) {
                if (this.isCarousel()) {
                    this.killCarousel()
                }
            }
        } else {
            this.initCarousel()
        }
    },

    isCarousel() {
        if (this.carousel && this.$carousel.hasClass('slick-initialized')) {
            return true
        } else {
            return false
        }
    },

    initCarousel() {
        let carouselSettings = {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            cssEase: 'cubic-bezier(1, 0.19, 0.25, 1)',
            prevArrow: '<button type="button" class="slick-brand-prev"><svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg"><path d="M-.06 12.646L12.645-.06l1.415 1.415L2.769 12.646 14.06 23.94l-1.415 1.415z" fill="#000" fill-rule="nonzero"/></svg></button>',
            nextArrow: '<button type="button" class="slick-brand-next"><svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg"><path d="M15.06 12.646L2.355 25.354.939 23.939l11.292-11.293L.94 1.354 2.354-.061z" fill="#000" fill-rule="nonzero"/></svg></button>',
            // variableWidth: true,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        dots: false,
                        slidesToShow: 1,
                        centerMode: true,
                        adaptiveHeight: true,
                        variableWidth: false,
                    }
                },
            ]

        }

        // Set slick settings based on available elements
        if (this.count < 4) {
            if (this.count > 0) {
                carouselSettings.slidesToShow = this.count
                carouselSettings.slidesToScroll = this.count
            }
        }

        this.$container.find('.product-recommendation-slider').on('init', function (event, slick) {
            let slidePager = slick.currentSlide + 1 + ' / ' + slick.slideCount
            $('.number-pager .current-page').html(slidePager)
        })

        this.carousel = this.$container.find('.product-recommendation-slider').slick(carouselSettings)

        this.carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            let slidePager = slick.currentSlide + 1 + ' / ' + slick.slideCount
            $('.number-pager .current-page').html(slidePager)
        })
    },

    killCarousel() {
        if (this.carousel && this.$carousel.hasClass('slick-initialized')) {
            this.$carousel.slick('unslick')
            this.carousel = null
        }
    }
})